'use client';

import { useState, useTransition } from 'react';

import { gatherAttribution } from '@/lib/pay/attribution';
import { payUrlFor, useHostedFallback } from '@/lib/pay/cta';
import { initiateCheckout } from '@/lib/tracking/dispatch';

type Tier = 'solo' | 'pro' | 'escala' | 'agencia';

interface Props {
  tier: Tier;
  highlight?: boolean;
}

export function CheckoutCta({ tier, highlight = false }: Props) {
  const [isPending, startTransition] = useTransition();
  const [error, setError] = useState<string | null>(null);
  const hostedFallback = useHostedFallback();

  return (
    <>
      <button
        type="button"
        disabled={isPending}
        className={highlight ? 'cta primary' : 'cta ghost'}
        onClick={() => {
          setError(null);
          // InitiateCheckout dispara ao ABRIR o checkout (assim que o user clica),
          // com a atribuição do tracker (pixelId/fbc/fbp/utm) embutida no envelope.
          // Síncrono, antes do POST/redirect, pra garantir o envio.
          initiateCheckout({ content_name: tier, content_category: 'subscription' });
          if (hostedFallback) {
            startTransition(async () => {
              const res = await fetch(`/api/checkout/${tier}?currency=brl`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attribution: gatherAttribution() }),
              });
              const json = (await res.json()) as { url?: string; error?: string };
              if (json.url) window.location.assign(json.url);
              else setError(json.error ?? 'erro desconhecido');
            });
          } else {
            window.location.assign(payUrlFor(tier));
          }
        }}
      >
        {isPending ? 'Carregando…' : 'Escolher este plano'}
      </button>
      {error ? <p className="cta-err">{error}</p> : null}
    </>
  );
}
